// Vendored from react-flexbox@3.1.4 (lib/index.js).
// The upstream package was last published in 2017 and declares and can't be installed with react 17.

import React, { Component } from 'react';

const flexStyle = {
  boxSizing: 'border-box',
  display: 'flex',
  flexWrap: 'nowrap',
  flex: '1 0 auto',
  justifyContent: 'space-between',
  alignContent: 'space-between',
  alignItems: 'stretch',
};

const mixProps = (style, props) => {
  const divStyle = {};

  if (props.row) {
    divStyle.flexDirection = 'row';
  } else if (props.column) {
    divStyle.flexDirection = 'column';
  }

  if (typeof props.width === 'number') {
    divStyle.flexGrow = props.width;
  } else if (props.width) {
    divStyle.flexBasis = 'auto';
    divStyle.flexGrow = 0;
    divStyle.flexShrink = 0;
    divStyle.width = props.width;
  }

  if (props.height) {
    divStyle.flexBasis = 'auto';
    divStyle.flexGrow = 0;
    divStyle.flexShrink = 0;
    divStyle.height = props.height;
  }

  if (props.style) {
    return { ...flexStyle, ...style, ...divStyle, ...props.style };
  }

  return { ...flexStyle, ...style, ...divStyle };
};

export default class View extends Component {
  render() {
    const style = mixProps({}, this.props);
    if (this.props.auto) {
      style.flex = '0 0 auto';
    }

    const { row, column, auto, ...divProps } = this.props;

    return (
      <div {...divProps} style={style}>
        {this.props.children}
      </div>
    );
  }
}
